/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./game.vue?vue&type=template&id=f5798424&scoped=true"
import script from "./game.vue?vue&type=script&lang=js"
export * from "./game.vue?vue&type=script&lang=js"
import style0 from "./game.vue?vue&type=style&index=0&id=f5798424&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5798424",
  null
  
)

export default component.exports